import numeral from 'numeral';
import moment from 'moment';
import { maxDescriptionLength } from './constants';

export default (Vue) => {
  Vue.filter('percentFormatInt', (value) => {
    return numeral(value).format('0%')
  });

  Vue.filter('descriptionLimit', (value) => {
    if (!value) {
      return;
    }
    const limitLength = maxDescriptionLength;
    if (value.length <= limitLength) {
      return limitLength;
    }
    return value.substr(0, maxDescriptionLength) + '...';
  });

  Vue.filter('dateFormat', (value) => {
    if (!value) return ''
    const dataTime = moment(value);
    return dataTime.format("YYYY/MM/DD");
  });

  Vue.filter('creditDateFormat', (value) => {
    if (!value) return ''
    const dataTime = moment(value);
    return dataTime.format("MM/YYYY");
  });
}



// WEBPACK FOOTER //
// ./src/filter.js